import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import Link from "../../../components/Link/Link";
import style from './vacantblock.module.scss';
import { useEffect, useState } from 'react';
import { fetchVacantInfo } from '../../../services/api'; // Новая функция

const VacantBlock = () => {
    const { settings } = useAccessibility();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';
    const tableBorderColor = settings.contrast === 'default' ? '#ddd' : 'var(--text-primary)';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchVacantInfo();
                // Данные теперь в response.data[0].attributes
                setData(response.data[0].attributes);
                console.log('Vacant data:', response.data[0].attributes);
            } catch (err) {
                console.error('Error fetching vacant data:', err);
                setError('Не удалось загрузить данные. Пожалуйста, попробуйте позже.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Format stage names for display
    const formatStage = (stage) => {
        const stageMap = {
            'НП': 'этап начальной подготовки',
            'УТ': 'учебно-тренировочный этап (этап спортивной специализации)',
            'ССМ': 'этап совершенствования спортивного мастерства',
            'ВСМ': 'высшее спортивное мастерство'
        };
        return `${stage} (${stageMap[stage] || stage})`;
    };

    // File link component
    const FileLink = ({ file, label, fallbackUrl, fallbackExt }) => {
        if (file?.data?.attributes?.url) {
            return (
                <Link
                    href={`${file.data.attributes.url}`}
                    children={`${label} (${file.data.attributes.ext || 'PDF'})`}
                    color={linkColor}
                    aria-label={`Скачать документ: ${label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                />
            );
        }
        if (fallbackUrl) {
            return (
                <Link
                    href={fallbackUrl}
                    children={`${label} (${fallbackExt})`}
                    color={linkColor}
                    aria-label={`Скачать документ: ${label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                />
            );
        }
        return null;
    };

    if (loading) {
        return (
            <Block
                background={backgroundColor}
                width="75%"
                height="200px"
                justifyContent="center"
                alignItems="center"
            >
                <p style={{ color: textColor }}>Загрузка данных...</p>
            </Block>
        );
    }

    if (error) {
        return (
            <Block
                background={backgroundColor}
                width="75%"
                height="200px"
                justifyContent="center"
                alignItems="center"
            >
                <p style={{ color: textColor }}>{error}</p>
            </Block>
        );
    }

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='ВАКАНТНЫЕ МЕСТА ДЛЯ ПРИЕМА (ПЕРЕВОДА) ОБУЧАЮЩИХСЯ'
            headerColor={textColor}
            id='vacant'
            aria-label="Вакантные места для приема и перевода обучающихся"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        {/* General Info Section */}
                        <section aria-labelledby="general-info">
                            <h4 id="general-info" className={style.header} style={{ color: textColor }}>
                                Набор поступающих 2025
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                <p>{data?.Description || "ГБУ ДО КК «СШОР «Самбо» объявляет набор поступающих для прохождения дополнительных образовательных программ спортивной подготовки по видам спорта «бокс», «дзюдо», «рукопашный бой», «самбо», «спортивная борьба»."}</p>
                                <p>Реализация программ будет проходить в городе Краснодар и муниципальных районах Краснодарского края.</p>
                                <Link
                                    href="/about/applicant/"
                                    children="Сведения для поступающих"
                                    color={linkColor}
                                    fontFamily='Roboto, sans-serif'
                                    fontSize='1rem'
                                    fontWeight='500'
                                    aria-label="Перейти к сведениям для поступающих"
                                />
                            </div>
                        </section>

                        {/* Admission Schedule Section */}
                        <section aria-labelledby="admission-schedule">
                            <h4 id="admission-schedule" className={style.header} style={{ color: textColor }}>
                                График приема 2025
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                <table 
                                    className={style.table}
                                    aria-label="График приема поступающих 2025"
                                    style={{ borderColor: tableBorderColor }}
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">Мероприятие</th>
                                            <th scope="col">Дата</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.Schedule?.map((event) => (
                                            <tr key={event.id}>
                                                <td>{event.Name}</td>
                                                <td>{event.Date} ({event.Weekday})</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </section>

                        {/* Vacant Positions Section */}
                        <section aria-labelledby="vacant-positions">
                            <h4 id="vacant-positions" className={style.header} style={{ color: textColor }}>
                                Вакантные места на 2025 год
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                {/* Группируем вакантные места по местоположению */}
                                {(() => {
                                    const locations = [...new Set(data?.VacantPlace?.map(item => item.Location) || [])];
                                    return locations.map(location => (
                                        <div key={location}>
                                            <h5>{location}</h5>
                                            <table 
                                                className={style.table}
                                                aria-label={`Вакантные места в ${location}`}
                                                style={{ borderColor: tableBorderColor }}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Вид спорта</th>
                                                        <th scope="col">Этап подготовки</th>
                                                        <th scope="col">Количество мест</th>
                                                        <th scope="col">Требования</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data?.VacantPlace
                                                        ?.filter(item => item.Location === location)
                                                        .map((item, index, array) => (
                                                        <tr key={item.id}>
                                                            {index === 0 || array[index - 1].Sport !== item.Sport ? (
                                                                <td rowSpan={array.filter(i => i.Sport === item.Sport).length}>
                                                                    {item.Sport}
                                                                </td>
                                                            ) : null}
                                                            <td>{formatStage(item.Stage)}</td>
                                                            <td>{item.Number}</td>
                                                            <td>{item.Requirements}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ));
                                })()}

                                <h5>Архивные данные о наборе (2024 год)</h5>
                                <FileLink 
                                    file={data?.ArchiveFile}
                                    label="Архив вакантных мест 2024"
                                    fallbackUrl="/documents/archive_vacancies_2024.pdf"
                                    fallbackExt="PDF"
                                />
                            </div>
                        </section>

                        {/* Abbreviations Section */}
                        <section aria-labelledby="abbreviations">
                            <h4 id="abbreviations" className={style.header} style={{ color: textColor }}>
                                Условные обозначения
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                <ul className={style.list}>
                                    <li><strong>НП</strong> - этап начальной подготовки</li>
                                    <li><strong>УТ</strong> - учебно-тренировочный этап (этап спортивной специализации)</li>
                                    <li><strong>ССМ</strong> - этап совершенствования спортивного мастерства</li>
                                    <li><strong>ВСМ</strong> - этап высшего спортивного мастерства</li>
                                    <li>Цифра рядом с этапом обозначает год подготовки (например, НП-2 - второй год этапа начальной подготовки)</li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </div>
            </FadeIn>
        </Block>
    );
};

export default VacantBlock;